// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabs {
  margin-top: 1rem;
}

.tab-buttons {
  display: flex;
  border-bottom: 2px solid #dee2e6;
  margin-bottom: 1.5rem;
}

.tab-btn {
  padding: 0.75rem 1.5rem;
  border: none;
  background: none;
  cursor: pointer;
  border-bottom: 3px solid transparent;
  font-weight: 500;
  color: #666;
  transition: all 0.2s;
}

.tab-btn:hover {
  color: #333;
  background-color: #f8f9fa;
}

.tab-btn.active {
  color: #1976d2;
  border-bottom-color: #1976d2;
  background-color: #f8f9fa;
}

.tab-content {
  padding: 1rem 0;
}

.two-cols {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 2rem;
  margin-bottom: 2rem;
}

.col-left h4,
.col-right h4 {
  margin-bottom: 1rem;
  color: #333;
  font-size: 1.1rem;
}

.template-selector {
  margin-bottom: 1rem;
}

.template-selector label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #555;
}

.template-selector select {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  background-color: white;
}

.tab-content textarea {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  margin-bottom: 1rem;
  box-sizing: border-box;
  resize: vertical;
  font-family: inherit;
  font-size: 0.9rem;
}

.tab-content label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
  font-weight: 500;
  color: #555;
}

.tab-content input[type="checkbox"] {
  margin: 0;
}

.analysis-buttons {
  display: flex;
  gap: 1rem;
  margin: 1rem 0;
}

.analyze-btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  background-color: #1976d2;
  color: white;
}

.analyze-btn:hover:not(:disabled) {
  background-color: #1565c0;
}

.analyze-btn.secondary {
  background-color: #f8f9fa;
  color: #1976d2;
  border: 1px solid #1976d2;
}

.analyze-btn.secondary:hover:not(:disabled) {
  background-color: #e3f2fd;
}

.analyze-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.analysis-result {
  margin-top: 1rem;
  padding: 1.5rem;
  background-color: white;
  border: 1px solid #dee2e6;
  border-radius: 8px;
}

.analysis-result h4,
.analysis-result h5 {
  color: #333;
  margin-bottom: 1rem;
}

.result-content {
  line-height: 1.6;
  color: #444;
  margin-bottom: 1.5rem;
  white-space: pre-wrap;
}

.sources {
  border-top: 1px solid #dee2e6;
  padding-top: 1rem;
}

.sources h5 {
  margin-bottom: 0.5rem;
  color: #555;
  font-size: 0.9rem;
}

.sources ul {
  list-style: none;
  padding: 0;
}

.sources li {
  padding: 0.25rem 0;
  color: #666;
  font-size: 0.9rem;
}

.sources li::before {
  content: "• ";
  color: #1976d2;
  margin-right: 0.5rem;
}

.info-box {
  background-color: #e3f2fd;
  color: #1976d2;
  padding: 1rem;
  border-radius: 6px;
  border-left: 4px solid #1976d2;
  margin-bottom: 1rem;
}

.info-box.success {
  background-color: #e8f5e8;
  color: #2e7d32;
  border-left-color: #2e7d32;
}

.info-box.warning {
  background-color: #fff3e0;
  color: #f57c00;
  border-left-color: #f57c00;
}`, "",{"version":3,"sources":["webpack://./src/components/Point4.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,gBAAgB;EAChB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,0BAA0B;AAC5B","sourcesContent":[".tabs {\n  margin-top: 1rem;\n}\n\n.tab-buttons {\n  display: flex;\n  border-bottom: 2px solid #dee2e6;\n  margin-bottom: 1.5rem;\n}\n\n.tab-btn {\n  padding: 0.75rem 1.5rem;\n  border: none;\n  background: none;\n  cursor: pointer;\n  border-bottom: 3px solid transparent;\n  font-weight: 500;\n  color: #666;\n  transition: all 0.2s;\n}\n\n.tab-btn:hover {\n  color: #333;\n  background-color: #f8f9fa;\n}\n\n.tab-btn.active {\n  color: #1976d2;\n  border-bottom-color: #1976d2;\n  background-color: #f8f9fa;\n}\n\n.tab-content {\n  padding: 1rem 0;\n}\n\n.two-cols {\n  display: grid;\n  grid-template-columns: 1fr 2fr;\n  gap: 2rem;\n  margin-bottom: 2rem;\n}\n\n.col-left h4,\n.col-right h4 {\n  margin-bottom: 1rem;\n  color: #333;\n  font-size: 1.1rem;\n}\n\n.template-selector {\n  margin-bottom: 1rem;\n}\n\n.template-selector label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  color: #555;\n}\n\n.template-selector select {\n  width: 100%;\n  padding: 0.5rem;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  background-color: white;\n}\n\n.tab-content textarea {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  margin-bottom: 1rem;\n  box-sizing: border-box;\n  resize: vertical;\n  font-family: inherit;\n  font-size: 0.9rem;\n}\n\n.tab-content label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n  font-weight: 500;\n  color: #555;\n}\n\n.tab-content input[type=\"checkbox\"] {\n  margin: 0;\n}\n\n.analysis-buttons {\n  display: flex;\n  gap: 1rem;\n  margin: 1rem 0;\n}\n\n.analyze-btn {\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  background-color: #1976d2;\n  color: white;\n}\n\n.analyze-btn:hover:not(:disabled) {\n  background-color: #1565c0;\n}\n\n.analyze-btn.secondary {\n  background-color: #f8f9fa;\n  color: #1976d2;\n  border: 1px solid #1976d2;\n}\n\n.analyze-btn.secondary:hover:not(:disabled) {\n  background-color: #e3f2fd;\n}\n\n.analyze-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.analysis-result {\n  margin-top: 1rem;\n  padding: 1.5rem;\n  background-color: white;\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n}\n\n.analysis-result h4,\n.analysis-result h5 {\n  color: #333;\n  margin-bottom: 1rem;\n}\n\n.result-content {\n  line-height: 1.6;\n  color: #444;\n  margin-bottom: 1.5rem;\n  white-space: pre-wrap;\n}\n\n.sources {\n  border-top: 1px solid #dee2e6;\n  padding-top: 1rem;\n}\n\n.sources h5 {\n  margin-bottom: 0.5rem;\n  color: #555;\n  font-size: 0.9rem;\n}\n\n.sources ul {\n  list-style: none;\n  padding: 0;\n}\n\n.sources li {\n  padding: 0.25rem 0;\n  color: #666;\n  font-size: 0.9rem;\n}\n\n.sources li::before {\n  content: \"• \";\n  color: #1976d2;\n  margin-right: 0.5rem;\n}\n\n.info-box {\n  background-color: #e3f2fd;\n  color: #1976d2;\n  padding: 1rem;\n  border-radius: 6px;\n  border-left: 4px solid #1976d2;\n  margin-bottom: 1rem;\n}\n\n.info-box.success {\n  background-color: #e8f5e8;\n  color: #2e7d32;\n  border-left-color: #2e7d32;\n}\n\n.info-box.warning {\n  background-color: #fff3e0;\n  color: #f57c00;\n  border-left-color: #f57c00;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
